import React from 'react';

interface Props {
  currentPage: number;
  totalPages: number;
  onGoTo: (page: number) => void;
}

export function PaginationControls({ currentPage, totalPages, onGoTo }: Props) {
  const maxSize = 10;
  // Windows page in fixed blocks so the ellipsis lands the clicked page at the
  // block edge (start for trailing, end for leading) instead of re-centering.
  const startPage = Math.floor(currentPage / maxSize) * maxSize;
  const endPage = Math.min(totalPages - 1, startPage + maxSize - 1);
  const pages = Array.from({ length: Math.max(endPage - startPage + 1, 1) }, (_, i) => startPage + i);

  return (
    <ul className="pagination pagination-sm">
      <li className={currentPage === 0 ? 'disabled' : ''}>
        <a onClick={() => currentPage > 0 && onGoTo(0)}>First</a>
      </li>
      <li className={currentPage === 0 ? 'disabled' : ''}>
        <a onClick={() => currentPage > 0 && onGoTo(currentPage - 1)}>Previous</a>
      </li>
      {startPage > 0 && (
        <li>
          <a onClick={() => onGoTo(startPage - 1)}>…</a>
        </li>
      )}
      {pages.map(p => (
        <li key={p} className={p === currentPage ? 'active' : ''}>
          <a onClick={() => onGoTo(p)}>{p + 1}</a>
        </li>
      ))}
      {endPage < totalPages - 1 && (
        <li>
          <a onClick={() => onGoTo(endPage + 1)}>…</a>
        </li>
      )}
      <li className={currentPage === Math.max(totalPages - 1, 0) ? 'disabled' : ''}>
        <a onClick={() => currentPage < totalPages - 1 && onGoTo(currentPage + 1)}>Next</a>
      </li>
      <li className={currentPage === Math.max(totalPages - 1, 0) ? 'disabled' : ''}>
        <a onClick={() => currentPage < totalPages - 1 && onGoTo(totalPages - 1)}>Last</a>
      </li>
    </ul>
  );
}
